import React, { useContext } from "react";
import * as Constants from "../SettingsConstant";
import Alert from "@amzn/meridian/alert";
import { FormattedMessage } from "react-intl";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { SettingsContext } from "./SettingsContext";

const UpdatePlanResponse = () => {
  const { viewModel, dispatch } = useContext(SettingsContext);

  const getModalType = (updateResponseModalType) => {
    if (updateResponseModalType === Constants.MODAL_SUCCESS) return "success";
    else if (updateResponseModalType === Constants.MODAL_ERROR) return "error";
  };

  return (
    <Modal
      type="dialog"
      open={
        viewModel.showUpdatePlanResponseModal === Constants.MODAL_SUCCESS ||
        viewModel.showUpdatePlanResponseModal === Constants.MODAL_ERROR
      }
      closeLabel="Close"
      describedById="modal-description"
    >
      <div>
        <Alert
          type={getModalType(viewModel.showUpdatePlanResponseModal)}
          size="xlarge"
        >
          <FormattedMessage
            id="message"
            defaultMessage="{message}"
            values={{ message: viewModel.messageToDisplay }}
          ></FormattedMessage>
        </Alert>
      </div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button
            type="secondary"
            size="small"
            onClick={() =>
              dispatch({
                type: "SHOW_UPDATE_PLAN_RESPONSE_MODAL",
                modalState: Constants.MODAL_RESET,
              })
            }
          >
            Close
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default UpdatePlanResponse;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/UpdatePlanResponse.js